import { mapLocale, mapLocaleString, mapPrimeUser } from '@/mappers';

export * from './types';

import type { AxiosInstance, AxiosResponse } from 'axios';
import type { ILocaleData, ILocaleString, IUserData } from '@/entities';
import type {
  IApiLocaleResponse,
  IApiLocaleStringResponse,
  IApiResponse,
  IApiUserResponse,
  IPrimeResponse
} from '@/services';

function getReferralCodeFromSearch(): string | null {
  const params = new URLSearchParams(window.location.search);
  return params.get('referralCode');
}

export class ApiUserEndpoint {
  axios: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.axios = axiosInstance;
  }

  async fetchUser(): Promise<{ user: IUserData; referralCode: string }> {
    const referralCode = getReferralCodeFromSearch();

    if (referralCode) {
      history.replaceState(null, '', location.origin + location.pathname);
    }

    const response: AxiosResponse<IApiResponse<IApiUserResponse>> = await this.axios
      .get(`account/me${referralCode ? `?code=${referralCode}` : ''}`)
      .catch(() => Promise.reject());

    if (response && response.data.isSuccess && response.data.data?.primeUser) {
      return {
        user: mapPrimeUser(response.data.data.primeUser),
        referralCode: response.data.data.referralCode
      };
    }

    return Promise.reject();
  }

  async uploadAvatar(avatar: string): Promise<boolean> {
    const response: AxiosResponse<IApiResponse<{ avatarUrl: string }>> = await this.axios
      .put(
        `users/upload`,
        {
          imageBase64: avatar
        },
        {}
      )
      .catch(() => Promise.reject());

    if (response && response.data.isSuccess) {
      return true;
    }

    return Promise.reject();
  }

  // async fetchLocales(catalogIds: string[]): Promise<ILocaleData[]> {
  //   const response: AxiosResponse<
  //     IApiResponse<
  //       {
  //         id: number;
  //         locales: IApiLocaleResponse[];
  //       }[]
  //     >
  //   > = await this.axios.get('locales').catch(() => Promise.reject());
  //
  //   if (response?.data.data) {
  //     const uniqueLocales = response.data.data
  //       .flatMap((item) => item.locales.map(mapLocale))
  //       .reduce((map, locale) => map.set(locale.id, locale), new Map<number, ILocaleData>());
  //
  //     return Array.from(uniqueLocales.values());
  //     // const catalog = response.data.data.find((item) => catalogIds.includes(item.id.toString()));
  //     //
  //     // if (catalog) {
  //     //   return catalog.locales.map((locale) => mapLocale(locale));
  //     // }
  //   }
  //
  //   return Promise.reject();
  // }

  async fetchLocale(locale: string): Promise<ILocaleString[]> {
    const response: AxiosResponse<IApiResponse<IApiLocaleStringResponse[]>> = await this.axios
      .get('locales/download?locale=' + encodeURIComponent(locale))
      .catch(() => Promise.reject());

    if (response && response.data.isSuccess && response.data.data) {
      return response.data.data.map((localeString) => mapLocaleString(localeString));
    }

    return Promise.reject();
  }
}
